import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ExMenuRequisitionParamsState {
  params: any; // Define a more specific type if possible
  disableRequisition: boolean
}

const initialState: ExMenuRequisitionParamsState = {
  params: null,
  disableRequisition: false
};

const ExMenuRequisitionSliceParams = createSlice({
  name: 'menuRequisitionPlanParams',
  initialState,
  reducers: {
    setExMenuRequisitionParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
      state.disableRequisition = action.payload.disableRequisition !== undefined ? action.payload.disableRequisition : state.disableRequisition;
    },
  },
});

export const { setExMenuRequisitionParams } = ExMenuRequisitionSliceParams.actions;

export default ExMenuRequisitionSliceParams.reducer;

